import apiClient from '../api';

const API_PATH = '/trucks';

export const getAllTrucks = () => {
  return apiClient.get(API_PATH);
};

export const getTruckById = (id) => {
  return apiClient.get(`${API_PATH}/${id}`);
};

export const createTruck = (truckData) => {
  return apiClient.post(API_PATH, truckData);
};

export const updateTruck = (id, truckData) => {
  return apiClient.patch(`${API_PATH}/${id}`, truckData);
};

export const deleteTruck = (id) => {
  return apiClient.delete(`${API_PATH}/${id}`);
};

export const getTruckDocuments = (truckId) => {
  return apiClient.get(`${API_PATH}/${truckId}/documents`);
};

export const addTruckDocument = (truckId, documentData) => {
  return apiClient.post(`${API_PATH}/${truckId}/documents`, documentData);
};

export const updateTruckDocument = (truckId, documentId, documentData) => {
  return apiClient.put(`${API_PATH}/${truckId}/documents/${documentId}`, documentData);
};

export const deleteTruckDocument = (truckId, documentId) => {
  return apiClient.delete(`${API_PATH}/${truckId}/documents/${documentId}`);
}; 